<template>
  <layout-basic>
    <section class="result-section">
      <v-container>
        <v-row justify="center">
          <v-col cols="12" sm="10" md="7" lg="6">
            <v-card class="result-card" flat>
              <div class="result-body">
                <h1 class="font-sora result-title">Your payment was not completed</h1>
                <p class="result-text">
                  Your signed agreement is safe and nothing has been charged.
                </p>

                <v-btn
                  v-if="uuid"
                  class="result-primary-btn"
                  depressed
                  block
                  @click="returnToPayment"
                >
                  Return to payment
                </v-btn>

                <p class="result-secondary">
                  <a href="#" @click.prevent="startAgain">Start again</a>
                </p>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </section>
  </layout-basic>
</template>

<script>
import LayoutBasic from '@/layouts/Dashboard';
import PurchaseAPI from '@/Api/purchase.js';

const STORAGE_KEY = 'improve_purchase_uuid';

export default {
  name: 'GetStartedCancel',
  components: { LayoutBasic },
  data() {
    return {
      uuid: null,
    };
  },
  metaInfo() {
    return {
      title: 'Payment not completed',
      meta: [{ name: 'robots', content: 'noindex' }],
    };
  },
  created() {
    this.uuid =
      this.$route.query.purchase || PurchaseAPI.storageGet(STORAGE_KEY) || null;
  },
  methods: {
    // Back to the payment step, which owns the payment logic: it offers card
    // and bank transfer, reopens the same Checkout session, and picks up
    // whatever state the purchase is now in (expired, invoiced, already paid).
    returnToPayment() {
      if (!this.uuid) return;
      PurchaseAPI.storageSet(STORAGE_KEY, this.uuid);
      this.$router.push('/get-started');
    },
    startAgain() {
      PurchaseAPI.storageRemove(STORAGE_KEY);
      this.$router.push('/get-started');
    },
  },
};
</script>

<style scoped>
.result-section {
  --navy: var(--brand-navy, #002458);
  --teal: var(--brand-teal, #08a0a8);
  --grey: var(--brand-grey, #6b7280);
  --line: #e6ebf1;
  --tint: #eef8f8;
  background: #f7f9fb;
  padding: 72px 0 110px;
  min-height: 60vh;
}

.result-card {
  background: #ffffff;
  border: 1px solid var(--line);
  border-radius: 14px;
  padding: 44px 36px 46px;
  box-shadow: 0 12px 40px rgba(0, 36, 88, 0.06);
}

.result-body {
  text-align: center;
}

.result-title {
  font-size: 26px;
  line-height: 1.25;
  font-weight: 700;
  color: var(--navy);
  margin-bottom: 12px;
}

.result-text {
  font-size: 16px;
  color: #2c3a4b;
  margin: 0 0 22px;
}

.result-primary-btn {
  background-color: var(--navy) !important;
  color: #ffffff !important;
  text-transform: none !important;
  font-weight: 700 !important;
  font-size: 16px !important;
  letter-spacing: 0.01em !important;
  border-radius: 8px !important;
  height: 52px !important;
}

.result-primary-btn:hover {
  background-color: var(--teal) !important;
}

.result-secondary {
  margin: 18px 0 0;
  font-size: 14px;
}

.result-secondary a {
  color: var(--teal);
  font-weight: 700;
  text-decoration: none;
}

@media screen and (max-width: 600px) {
  .result-section {
    padding: 44px 0 80px;
  }

  .result-card {
    padding: 32px 20px 34px;
  }

  .result-title {
    font-size: 22px;
  }
}
</style>
